import { Divider, Row, SizedBox } from "../CommonBaseComponents";
import { C1Text } from "../text/CustomText";
import { Theme } from "../../Theme";

function CustomSubTab({ tabs, activeTab, onClick }) {
    return (
        <SizedBox border={`1px solid ${Theme.color.gray200}`} borderRadius={"8px"} width={"auto"} height={"36px"}>
            <Row>
                {tabs.map((tab, index) => (
                    <>
                        <SizedBox
                            key={tab.value}
                            width={"auto"}
                            padding={"0 19px"}
                            height={"34px"}
                            cursor={"pointer"}
                            backgroundColor={activeTab === tab.value ? Theme.color.neutral100 : "transparent"}
                            onClick={() => onClick(tab.value)}
                            hoverBackgroundColor={
                                activeTab === tab.value ? Theme.color.zinc100 : Theme.color.neutral100_01
                            }
                        >
                            <C1Text
                                fontColor={activeTab === tab.value ? Theme.color.zinc850 : Theme.color.gray400}
                                fontWeight={activeTab === tab.value ? "600" : "500"}
                            >
                                {tab.label}
                            </C1Text>
                        </SizedBox>
                        {index !== tabs.length - 1 && <Divider orientation={"vertical"} height={"34px"} />}
                    </>
                ))}
            </Row>
        </SizedBox>
    );
}

export default CustomSubTab;
